module.exports = __webpack_public_path__ + "static/media/git.438c93c0.png";